import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/lib/Form';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import InfoPopOver from './InfoPopOver';
import CustomFormGroup from './CustomFormGroup';

const CheckboxOrRadioGroup = (props) => (
  <div>
    <CustomFormGroup valid={props.valid} >
      <ControlLabel>{props.title}</ControlLabel>
      <div className="checkbox-group">
        {props.options.map((opt, i) => {
          return (
            <ControlLabel key={opt[1]} className={props.checkBoxStyle ? props.checkBoxStyle : "checkbox-inline" }>
              <input
                className="form-checkbox"
                name={props.setName}
                id={props.setName+"_"+opt[1].split(' ').join('_').toLowerCase()}
                onChange={props.controlFunc}
                value={opt[1]}
                checked={ props.selectedOptions.includes(opt[1]) }
                type={props.type} />
                {opt[0]} {props.info ? <InfoPopOver popOverText={props.info[i]}/> : ''}
            </ControlLabel>
          );
        })}
      </div>
    </CustomFormGroup>
  </div>
);

CheckboxOrRadioGroup.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  setName: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array,
  controlFunc: PropTypes.func.isRequired,
  checkBoxStyle: PropTypes.string,
  info: PropTypes.array
};

export default CheckboxOrRadioGroup;
